import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * `items`: [{ name, path }]. Last item is current page (not linked).
 * `dark` for dark hero backgrounds.
 */
export default function Breadcrumbs({ items, dark = false }) {
  const base = dark ? "text-white/60" : "text-ink/55";
  const hover = dark ? "hover:text-white" : "hover:text-ink";
  const current = dark ? "text-blush" : "text-rose";
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs tracking-wide">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-1.5">
              {last ? (
                <span className={current} aria-current="page">
                  {it.name}
                </span>
              ) : (
                <>
                  <Link to={it.path} className={`${base} ${hover} transition-colors`}>
                    {it.name}
                  </Link>
                  <ChevronRight size={13} className={base} aria-hidden="true" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
